import * as ambassadorWixBookingsAvailabilityV1SlotAvailability from './bookings-availability-v1-slot-availability-availability-calendar.http.js';
import * as ambassadorWixBookingsAvailabilityV1SlotAvailabilityTypes from './bookings-availability-v1-slot-availability-availability-calendar.types.js';
import * as ambassadorWixBookingsAvailabilityV1SlotAvailabilityUniversalTypes from './bookings-availability-v1-slot-availability-availability-calendar.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryAvailability(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityUniversalTypes.QueryAvailabilityRequest,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityTypes.QueryAvailabilityRequest,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityUniversalTypes.QueryAvailabilityResponse,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityTypes.QueryAvailabilityResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsAvailabilityV1SlotAvailability.queryAvailability(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/availability/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getScheduleAvailability(): __PublicMethodMetaInfo<
  'GET',
  { scheduleId: string },
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityUniversalTypes.GetScheduleAvailabilityRequest,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityTypes.GetScheduleAvailabilityRequest,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityUniversalTypes.GetScheduleAvailabilityResponse,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityTypes.GetScheduleAvailabilityResponse
> {
  const payload = { scheduleId: ':scheduleId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsAvailabilityV1SlotAvailability.getScheduleAvailability(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/availability/schedule/{scheduleId}',
    pathParams: { scheduleId: 'scheduleId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculateMultiSlotAvailability(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityUniversalTypes.CalculateMultiSlotAvailabilityRequest,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityTypes.CalculateMultiSlotAvailabilityRequest,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityUniversalTypes.CalculateMultiSlotAvailabilityResponse,
  ambassadorWixBookingsAvailabilityV1SlotAvailabilityTypes.CalculateMultiSlotAvailabilityResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsAvailabilityV1SlotAvailability.calculateMultiSlotAvailability(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/availability/multislot',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SlotAvailability as SlotAvailabilityOriginal,
  Slot as SlotOriginal,
  SlotResource as SlotResourceOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  PhoneCall as PhoneCallOriginal,
  AvailabilityWaitingList as AvailabilityWaitingListOriginal,
  BookingPolicyViolations as BookingPolicyViolationsOriginal,
  NestedTimeSlot as NestedTimeSlotOriginal,
  QueryAvailabilityRequest as QueryAvailabilityRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  V2CustomerChoices as V2CustomerChoicesOriginal,
  QueryAvailabilityResponse as QueryAvailabilityResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  GetSlotAvailabilityRequest as GetSlotAvailabilityRequestOriginal,
  GetSlotAvailabilityResponse as GetSlotAvailabilityResponseOriginal,
  BookingPolicySettings as BookingPolicySettingsOriginal,
  GetScheduleAvailabilityRequest as GetScheduleAvailabilityRequestOriginal,
  GetScheduleAvailabilityResponse as GetScheduleAvailabilityResponseOriginal,
  ScheduleAvailability as ScheduleAvailabilityOriginal,
  CalculateMultiSlotAvailabilityRequest as CalculateMultiSlotAvailabilityRequestOriginal,
  RuleBasedConstraints as RuleBasedConstraintsOriginal,
  ResourcesFilter as ResourcesFilterOriginal,
  AvailabilityV2CustomerChoices as AvailabilityV2CustomerChoicesOriginal,
  CalculateMultiSlotAvailabilityResponse as CalculateMultiSlotAvailabilityResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  GetAvailabilityTimeSlotRequest as GetAvailabilityTimeSlotRequestOriginal,
  TimeSlotLocation as TimeSlotLocationOriginal,
  LocationLocationType as LocationLocationTypeOriginal,
  LocationLocationTypeWithLiterals as LocationLocationTypeWithLiteralsOriginal,
  CustomerChoices as CustomerChoicesOriginal,
  GetAvailabilityTimeSlotResponse as GetAvailabilityTimeSlotResponseOriginal,
  TimeSlot as TimeSlotOriginal,
  EventInfo as EventInfoOriginal,
  WaitingList as WaitingListOriginal,
  Service_availabilityBookingPolicyViolations as Service_availabilityBookingPolicyViolationsOriginal,
  AvailableResources as AvailableResourcesOriginal,
  Resource as ResourceOriginal,
  Service_availabilityNestedTimeSlot as Service_availabilityNestedTimeSlotOriginal,
  GetScheduleAvailabilityApplicationErrors as GetScheduleAvailabilityApplicationErrorsOriginal,
} from './bookings-availability-v1-slot-availability-availability-calendar.types.js';
